module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/47/assets/images/57e27195a5271a7080bbb14d3b1e2095.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_gem_1.svg
// module id = JXZx
// module chunks = 0